module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$router.message) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$router.message))]) : _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("You've reached this page because of an error.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success centered-button uppercase",
    on: {
      "click": function($event) {
        _vm.routeToLogin()
      }
    }
  }, [_vm._v("Return to Login")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-437a4d85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 425
// module chunks = 1